import Vue from 'vue'
import Router from 'vue-router'

import coreRoutes from './routes/core'
import candidatesRoutes from './routes/candidates'
import payoutStatementsRoutes from './routes/payout-statements'
import driversRoutes from './routes/drivers'
import cabinetRoutes from './routes/cabinet'
import paymentsRoutes from './routes/payments'
import transactionsRoutes from './routes/transactions'
import antifraudRoutes from './routes/antifraud'
import promotionsRoutes from './routes/promotions'
import payoutRoutes from './routes/payout'
import teamsRoutes from './routes/teams'
import dumpsRoutes from './routes/dumps'
import miscRoutes from './routes/misc'
import woltRoutes from './routes/wolt'
import ironParksRoutes from './routes/iron-parks'
import comebackRoutes from './routes/comeback'
import wildberriesRoutes from './routes/wildberries'

Vue.use(Router)

/// todo adopt
/// http://localhost:8080/payments/index
/// http://localhost:8080/transactions/statements/parks all tabs 

export default new Router({
    mode: 'history',
    base: '/',
    routes: [
        ...coreRoutes,
        ...candidatesRoutes,
        ...payoutStatementsRoutes,
        ...driversRoutes,
        ...cabinetRoutes,
        ...paymentsRoutes,
        ...transactionsRoutes,
        ...antifraudRoutes,
        ...promotionsRoutes,
        ...payoutRoutes,
        ...teamsRoutes,
        ...dumpsRoutes,
        ...miscRoutes,
        ...woltRoutes,
        ...ironParksRoutes,
        ...comebackRoutes,
        ...wildberriesRoutes,
    ]
})
